module.exports = __webpack_public_path__ + "img/zh_hk.726715a5.png";